import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';
import WidgetDropdownList from 'react-widgets/lib/DropdownList';
import FontAwesome from 'react-fontawesome';

class DropdownList extends Component {
	componentDidMount() {
		const { input: { onChange, value } } = this.props;

		if (value) {
			onChange(value);
		}
	}

	render() {
		const { name, label, horizontal, t, input: { onChange, value }, help, meta: { touched, error, warning }, required, options, clearable, valueField, valueComponent, placeholder, disabled, ...props } = this.props;

		const validationState = touched && (error && "error") || (warning && "warning") || null;

		const formControl = <WidgetDropdownList
			name={name}
			value={value}
			data={options}
			placeholder={placeholder || t('Common_Select')}
			onChange={item => onChange(valueField ? item[valueField] : item)}
			valueField={valueField}
			valueComponent={clearable ? WithClearableSelection(() => onChange(null), valueComponent, disabled) : valueComponent}
			disabled={disabled}
			{...props}	// textField, itemComponent, filter, onSearch
		/>;
		const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
		const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
		const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

		if (horizontal) {
			return (
				<FormGroup validationState={validationState} className='row'>
					<Col componentClass={ControlLabel} sm={3}>
						{label}{labelHint}
					</Col>
					<Col sm={9}>
						{formControl}
						{errorBlock}
						{helpBlock}
					</Col>
				</FormGroup>);
		}

		return (
			<FormGroup validationState={validationState}>
				<ControlLabel>{label}{labelHint}</ControlLabel>
				{formControl}
				{errorBlock}
				{helpBlock}
			</FormGroup>
		);
	}
}

const WithClearableSelection = (onClear, valueComponent, disabled) => {
	return ({ item }) => (
		<span>
			{valueComponent({ item })}
			{!disabled && <span onClick={onClear} style={{ float: 'right', cursor: 'pointer' }}><FontAwesome name='close' /></span>}
		</span>
	);
};

export default withNamespaces()(DropdownList);